import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { DashboardRoutingModule } from '@app/features/dashboard/dashboard-routing.module';
import { WeeklyServiceCalendarComponent } from '@app/features/dashboard/components/weekly-service-calendar/weekly-service-calendar.component';
import { WeeklyServiceCalendarBlockComponent } from '@app/features/dashboard/components/weekly-service-calendar-block/weekly-service-calendar-block.component';
import { DashboardComponent } from '@app/features/dashboard/dashboard.component';
import { DashboardPageComponent } from '@app/features/dashboard/pages/dashboard-page/dashboard-page.component';
import { SupportCaseWidgetComponent } from '@app/features/dashboard/components/support-case-widget/support-case-widget/support-case-widget.component';
import { ScrollingModule } from '@angular/cdk/scrolling';

const components = [
  DashboardComponent,
  DashboardPageComponent,
  WeeklyServiceCalendarComponent,
  WeeklyServiceCalendarBlockComponent,
  SupportCaseWidgetComponent,
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    DashboardRoutingModule,
    ScrollingModule,
  ],
  declarations: [...components],
})
export class DashboardModule {}
